import { Percent, ShoppingBasket, Users, ArrowRight, ArrowDown } from "lucide-react";

const STEPS = [
  {
    icon: Percent,
    kicker: "Step 01",
    title: "Project Fees",
    text: "A portion of project fees enters the ecosystem treasury automatically — no manual custody, no team discretion.",
    meta: "Fee: 4% • hard-coded routing",
  },
  {
    icon: ShoppingBasket,
    kicker: "Step 02",
    title: "Automated Purchases",
    text: "The system swaps accumulated fees into selected Solana assets — SOL, JUP, BONK, WIF, RAY — at target basket weights.",
    meta: "Jupiter routing • 5 curated assets",
  },
  {
    icon: Users,
    kicker: "Step 03",
    title: "Holder Allocations",
    text: "Snapshot metrics track $BASK balances and eligible holders receive proportional basket allocations — zero lockups.",
    meta: "Proportional • claimable to wallet",
  },
];

const Connector = ({ index }) => (
  <div className="hidden md:flex flex-col items-center justify-center flex-shrink-0 w-14 relative" aria-hidden="true">
    <div className="flow-line h-[2px] w-full rounded-full" style={{ animationDelay: `${index * 0.4}s` }} />
    <ArrowRight size={18} className="text-[#14F195] absolute -right-1 flow-arrow" style={{ animationDelay: `${index * 0.4}s` }} />
  </div>
);

const MobileConnector = ({ index }) => (
  <div className="flex md:hidden flex-col items-center py-1 relative h-12" aria-hidden="true">
    <div className="flow-line-v w-[2px] h-full rounded-full" style={{ animationDelay: `${index * 0.4}s` }} />
    <ArrowDown size={16} className="text-[#14F195] absolute -bottom-1 flow-arrow" style={{ animationDelay: `${index * 0.4}s` }} />
  </div>
);

export default function MechanismFlow() {
  return (
    <section className="py-24 px-6 bg-[#090612] border-b border-white/5" data-testid="mechanism-flow">
      <div className="max-w-6xl mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="mono-font text-xs uppercase tracking-widest text-[#9945FF] font-semibold">Autonomous Architecture</span>
          <h2 className="display-font uppercase text-3xl md:text-5xl text-white mt-2">How The Basket Mechanism Operates</h2>
          <p className="text-sm text-[#a8a1c2] mt-3">Three automated stages turn project fees into shared basket allocations — no staking complexity.</p>
        </div>

        <div className="flex flex-col md:flex-row items-stretch justify-center">
          {STEPS.map((step, i) => (
            <div key={step.title} className="contents">
              <div
                data-testid={`flow-step-${i + 1}`}
                className={`glass-panel ${i === 1 ? "glass-panel-glow" : ""} p-8 rounded-2xl relative flex-1 d1-up group hover:-translate-y-1 transition-transform duration-300`}
                style={{ animationDelay: `${i * 0.14}s` }}
              >
                <div className="w-12 h-12 rounded-xl bg-[#9945FF]/15 border border-[#9945FF]/40 flex items-center justify-center mb-5 group-hover:border-[#14F195]/60 transition-colors">
                  <step.icon size={22} className="text-[#14F195]" />
                </div>
                <div className="mono-font text-[10px] text-[#9945FF] uppercase tracking-widest mb-1">{step.kicker}</div>
                <h3 className="text-xl font-bold text-white mb-2 uppercase">{step.title}</h3>
                <p className="text-sm text-[#b5aed0] leading-relaxed">{step.text}</p>
                <div className="mt-6 pt-4 border-t border-white/10 text-xs mono-font text-[#14F195]">{step.meta}</div>
              </div>
              {i < STEPS.length - 1 && (
                <>
                  <Connector index={i} />
                  <MobileConnector index={i} />
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
